import { Link } from "react-router-dom"

export default function AuthLegalLink({
    to,
    children,
    className,
}: {
    to: string
    children: React.ReactNode
    className?: string
}) {
    return (
        <Link to={to} className={className}>
            {children}
        </Link>
    )
}
